module.exports = __webpack_public_path__ + "img/yxkdiag2.d6088172.svg";